import { connect } from 'react-redux';
import { requestGoalList } from 'src/redux/actions';
import TransactionAccountDetails from './transaction-account-details';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { requestGoalList })(TransactionAccountDetails);
